import React, { useState } from 'react';
import { TextField, Button, Box, Typography, Card, CardContent } from '@mui/material';
import { login } from '../api/api';
import loopwayIcon from '../assets/tn.svg';

const Login = () => {
    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');

    const handleLogin = async () => {
        try {
            const response = await login({ email, password });
            localStorage.setItem('token', response.data.token);
            
            window.location.href = '/dashboard';
        } catch (error) {
            alert('Login failed!');
        }
    };

    const handleKeyPress = (event) => {
        if (event.key === 'Enter') {
            handleLogin();
        }
    };

    return (
        <Box
            display="flex"
            flexDirection="column"
            alignItems="center"
            justifyContent="center"
            height="100vh"
            bgcolor="#f5f5f5"
        >
            <Card style={{ maxWidth: 400, width: '100%', padding: '20px' }}>
                <CardContent>
                    <Box display="flex" flexDirection="column" alignItems="center" mb={2}>
                        <img
                            src={loopwayIcon}
                            alt="Loopway Logo"
                            style={{ width: '50px', height: '50px', marginBottom: '10px' }}
                        />
                        <Typography variant="h4" align="center">
                            Login
                        </Typography>
                    </Box>
                    <TextField
                        label="Email"
                        variant="outlined"
                        fullWidth
                        margin="normal"
                        value={email}
                        onChange={(e) => setEmail(e.target.value)}
                    />
                    <TextField
                        label="Password"
                        type="password"
                        variant="outlined"
                        fullWidth
                        margin="normal"
                        value={password}
                        onChange={(e) => setPassword(e.target.value)}
                        onKeyPress={handleKeyPress} // Trigger login on Enter
                    />
                    <Box mt={2}>
                        <Button variant="contained" color="primary" fullWidth onClick={handleLogin}>
                            Login
                        </Button>
                    </Box>
                </CardContent>
            </Card>
        </Box>
    );
};

export default Login;
